import { memo } from 'react';
import { Box, Icon, Text } from '@nimbus-ds/components';
import { ExclamationTriangleIcon } from '@nimbus-ds/icons';
import { AbandonedCartPaymentAttemptDto } from '@tiendanube/common';
import { dateFormat, Format } from 'commons/utils/date';
import { PaymentMethodTitle } from './PaymentMethodTitle';
import usePaymentErrorCodeTranslation from './usePaymentErrorCodeTranslation';

interface PreviousPaymentAttemptItemProps {
  attempt: AbandonedCartPaymentAttemptDto;
}

function PreviousPaymentAttemptItemComponent({
  attempt,
}: Readonly<PreviousPaymentAttemptItemProps>) {
  const translateErrorCode = usePaymentErrorCodeTranslation(
    attempt.payment?.integrationType,
  );

  return (
    <Box display="flex" flexDirection="column" gap="2" alignItems="flex-start">
      {!!attempt.createdAt && (
        <Text fontSize="caption" color="neutral-textLow">
          {dateFormat(attempt.createdAt, Format.DAY_HOUR_MINUTE)}
        </Text>
      )}
      <PaymentMethodTitle attempt={attempt} />
      <Box display="flex" alignItems="center" gap="2">
        <Icon color="danger-textLow" source={<ExclamationTriangleIcon />} />
        <Text fontSize="base" fontWeight="regular" color="danger-textLow">
          {translateErrorCode(attempt.errorCode)}
        </Text>
      </Box>
    </Box>
  );
}

export const PreviousPaymentAttemptItem = memo(
  PreviousPaymentAttemptItemComponent,
);
